import React from "react";
import "./GlobalAgencyHero.css";
import businessImg from "../../../assets/banner/banner_secondary.jpeg";

const GlobalAgencyHero = () => {
  const handleSeeHowWeWork = () => {
    const targetSection = document.getElementById("how-it-works-section");

    if (targetSection) {
      targetSection.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <section className="global-hero">
      <div className="global-hero-container">
        <div className="map-section">
          <img
            src={businessImg}
            alt="World Map Network"
            className="global-image"
          />
        </div>

        <div className="content-section">
          <div className="content">
            <p className="subtitle" style={{ color: "#bd06d3" }}>
              Innovative Ideas
            </p>

            <h1 className="title">
              WE ARE A GLOBAL CREATIVE <br />{" "}
              <span style={{ color: "#00bfff" }}>ICONIC UNITY GROUP</span>
            </h1>

            <p className="description">
              At{" "}
              <span style={{ color: "#bd06d3", fontWeight: "800" }}>
                Iconic Unity Group
              </span>
              , we are committed to driving growth and innovation across a
              diverse range of industries. Our expertise spans digital
              solutions, furniture, software, travel and tourism, Hajj services,
              holidays, and automotive ventures, through our companies: Iconic
              Digital Solutions, Iconic Furniture Ltd, Iconic Soft Ltd, Iconic
              Tours & Travels Ltd, Iconic Hajj Group, Iconic Holidays, and
              Iconic Motors. By delivering tailored strategies in web design,
              branding, SEO, and digital marketing, we aim to enhance your
              online presence, increase engagement, and maximize returns. Let us
              help your business unlock its full potential through creative and
              impactful services that blend innovation with measurable results.
            </p>

            <div className="button-row">
              <button
                type="button"
                className="cta-button"
                onClick={handleSeeHowWeWork}
              >
                SEE HOW WE WORK
                <span className="button-icon">&rarr;</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GlobalAgencyHero;
